import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import Sidebarpo from "./Sidebarpo";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import 'bootstrap/dist/css/bootstrap.min.css';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Select from "react-select";

const ListPO = () => {
  const navigate = useNavigate();
  const [poData, setPoData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;
  const [selectedRFQ, setSelectedRFQ] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [clients, setClients] = useState([]);
  const [suppiler, setSupplier] = useState([]);
  const user = JSON.parse(localStorage.getItem("userdata"));
  const [poLength, setPoLength] = useState("");
  const [filterLatestUpdate, setFilterLatestUpdate] = useState("");
  const [filterSupplier, setFilterSupplier] = useState("");

  const [dateType, setDateType] = useState("");
  // client_po_date | client_delivery_date | supplier_delivery_date

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [file1, setFile1] = useState(null);

  useEffect(() => {
    fetchPOData();
    fetchClients();
    fetchSupplier();
  }, []);

  const fetchClients = () => {
    axios
      .get(`${BASE_URL}/api/client-get`)
      .then((res) => setClients(res.data))
      .catch((err) => console.error("Error fetching clients:", err));
  };
  const fetchSupplier = () => {
    axios
      .get(`${BASE_URL}/api/supplier-get`)
      .then((res) => {
        setSupplier(res.data);
      })
      .catch((err) => {
        console.error("Error fetching clients:", err);
      });
  };

  const latestUpdateOptions = [
    "Po Received From Client",
    "Po issued to supplier",
    "Po Under Progress",

    "Po Shipped",
    "Commercial Invoice Issue",
    "Payment Invoice Issue",
    "Payment Received",
    "Po Closed",
  ];

  const supplierPaymentOptions = [
    "Advance With Order",
    "Advance Before Dispatch",
    "OnCredit",
    "Stage Payment",
  ];

  const clientPaymentOptions = [
    "Payment Pending",
    "Payment Received",
    "Payment Delayed",
  ];

  const getBackgroundColor = (value) => {
    switch (value) {
      case "Po Received From Client":
        return "#ffe6cc";
      case "Po issued to supplier":
        return "#ffcccc";
      case "Po Under Progress":
        return "#ffffcc";
      case "Po Shipped":
        return "#ccffcc";
      case "Invoice Issue":
        return "#ccccff";
      case "Payment Received":
        return "#d9edf7";
      case "Po Closed":
        return "#dff0d8";

      case "Advance With Order":
        return "#f2dede";
      case "Advance Before Dispatch":
        return "#fcf8e3";
      case "OnCredit":
        return "#d9edf7";
      case "Stage Payment":
        return "#dff0d8";

      case "Payment Pending":
        return "#f9d6d5";
      case "Payment Delayed":
        return "#e3f2fd";
      default:
        return "#ffffff";
    }
  };

  const fetchPOData = () => {
    axios
      .get(`${BASE_URL}/api/get-po-data`)
      .then((response) => {
        const reverseData = response.data.reverse();
        setPoLength(reverseData.length);
        setPoData(reverseData);
      })
      .catch((error) => {
        console.error("Error fetching PO data:", error);
      });
  };

  const openStatusModal = (rfq) => {
    setSelectedRFQ({ ...rfq });
    // const modal = new window.bootstrap.Modal(document.getElementById("statusModal"));
    // modal.show();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "supplier_name" && value === "add_new") {
      window.location.href = "/supplierpo";
      // navigate("/supplierpo");
      // Redirect to supplier page
      return;
    }
    if (name === "client_name" && value === "add_new") {
      window.location.href = "/clientlist";

      // navigate("/clientlist");
      // Redirect to supplier page
      return;
    }
    // setSelectedRFQ((prev) => ({ ...prev, [name]: value }));
    setSelectedRFQ((prev) => {
      const updatedForm = {
        ...prev,
        [name]: value,
      };

      const clientName = updatedForm.client_name || "";
      const rfq = updatedForm.rfq_number || "";

      // Only if both fields are filled
      if (clientName.length >= 3 && rfq.length >= 6) {
        const clientCode = clientName.substring(0, 3).toUpperCase();
        const rfqSuffix = rfq.slice(-6);
        const poNumber = `${clientCode}-${poLength}-${rfqSuffix}`;

        updatedForm.supplier_po_number = poNumber;
      }

      return updatedForm;
    });
  };

  const submitStatusUpdate = async () => {
    const sendData = new FormData();

    // Append everything except rfq_attachment
    Object.entries(selectedRFQ).forEach(([key, value]) => {
      if (key !== "po_attachment") {
        sendData.append(key, value);
      }
    });
    sendData.append("old_file", selectedRFQ.po_attachment);

    // If a new file is selected
    if (file1 instanceof File) {
      sendData.append("po_attachment", file1);
    }

    try {
      await axios.post(
        `${BASE_URL}/api/update-po/${selectedRFQ.id}?_method=PUT`,
        sendData
      );
      fetchPOData();
      Swal.fire("Success", "PO updated successfully!", "success");
      handleSubmitCreatepo();
      // const modal = bootstrap.Modal.getInstance(document.getElementById("statusModal"));
      // modal.hide();
    } catch (error) {
      console.error("Status update failed:", error);
      Swal.fire("Error", "Failed to update status.", "error");
    }
  };

  const [selectedClients, setSelectedClients] = useState([]);
  const [checkAllClients, setCheckAllClients] = useState(true);

  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  const [checkAllSuppliers, setCheckAllSuppliers] = useState(true);

 const filteredData = poData
  .filter((po) => {
    /* 🔍 SEARCH */
    const matchSearch =
      !searchTerm ||
      Object.values(po).some((v) =>
        String(v || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );

    /* 🔹 LATEST UPDATE */
    const matchLatest =
      !filterLatestUpdate || po.latest_update === filterLatestUpdate;

    /* 🔹 SUPPLIER */
    const matchSupplier =
      !filterSupplier || po.supplier_name === filterSupplier;

    const clientMatch =
      checkAllClients || selectedClients.includes(po.client_name);

    const supplierMatch =
      checkAllSuppliers || selectedSuppliers.includes(po.pearlcon_contact);

    /* ✅ DATE FILTER (FIXED) */
    let matchDate = true;

    if (startDate || endDate) {
      // 👉 default dateType (important)
      const field = dateType || "client_po_date";

      const value = po[field];

      if (!value) return false;

      const poDate = new Date(value);
      if (isNaN(poDate)) return false;

      const from = startDate ? new Date(startDate) : null;
      const to = endDate ? new Date(endDate) : null;

      if (from && poDate < from) matchDate = false;
      if (to && poDate > to) matchDate = false;
    }

    return (
      matchSearch &&
      matchLatest &&
      matchSupplier &&
      clientMatch &&
      supplierMatch &&
      matchDate
    );
  })

  /* 🔥 SORT */
  .sort((a, b) => {
    const field = dateType || "client_po_date";

    const da = new Date(a[field]);
    const db = new Date(b[field]);

    if (isNaN(da)) return 1;
    if (isNaN(db)) return -1;

    return da - db;
  });

  // const filteredData = poData.filter((po) => {
  //   const matchSearch = Object.values(po).some((v) =>
  //     v?.toString().toLowerCase().includes(searchTerm.toLowerCase())
  //   );
  // const clientMatch =
  //   checkAllClients || selectedClients.includes(po.client_name);
  // const supplierMatch =
  //   checkAllSuppliers || selectedSuppliers.includes(po.pearlcon_contact);
  // return matchSearch && clientMatch && supplierMatch;
  // });

  const handleSubmitCreatepo = async () => {
    try {
      const response = await axios.post(
        "https://bimanager.nexteck.uk/api/messages",
        {
          user_id: user.id,
          type: "PO",
          message: " PO Edit",
          status: "0",
        }
      );
      console.log(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const getPaginationGroup = () => {
    let start = Math.floor((currentPage - 1) / 5) * 5;
    return new Array(Math.min(5, totalPages - start))
      .fill()
      .map((_, i) => start + i + 1);
  };

  const TruncatedText = ({ text, limit = 40 }) => {
    if (!text) return <span>-</span>;

    const truncated = text.length > limit ? text.slice(0, limit) + "..." : text;

    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id={`tooltip-${Math.random()}`}>{text}</Tooltip>}
      >
        <span style={{ cursor: "pointer" }}>{truncated}</span>
      </OverlayTrigger>
    );
  };

  const TruncatedTextSupplier = ({ text, limit = 15 }) => {
    if (!text) return <span>-</span>;

    const truncated = text.length > limit ? text.slice(0, limit) + "..." : text;

    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id={`tooltip-${Math.random()}`}>{text}</Tooltip>}
      >
        <span style={{ cursor: "pointer" }}>{truncated}</span>
      </OverlayTrigger>
    );
  };

  const limitWords = (text, charLimit = 50) => {
    if (!text) return "-";
    text = text.toString();
    return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
  };
  const limitWordstwo = (text, charLimit = 25) => {
    if (!text) return "-";
    text = text.toString();
    return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
  };

  const handleClientCheckboxChange = (name) => {
    if (selectedClients.includes(name)) {
      const updated = selectedClients.filter((c) => c !== name);
      setSelectedClients(updated);
      setCheckAllClients(false);
    } else {
      const updated = [...selectedClients, name];
      setSelectedClients(updated);
      setCheckAllClients(updated.length === clients.length);
    }
  };

  const handleClientCheckAll = () => {
    if (checkAllClients) {
      setSelectedClients([]);
      setCheckAllClients(false);
    } else {
      const all = clients.map((c) => c.client_name);
      setSelectedClients(all);
      setCheckAllClients(true);
    }
  };

  const handleSupplierCheckboxChange = (name) => {
    if (selectedSuppliers.includes(name)) {
      const updated = selectedSuppliers.filter((s) => s !== name);
      setSelectedSuppliers(updated);
      setCheckAllSuppliers(false);
    } else {
      const updated = [...selectedSuppliers, name];
      setSelectedSuppliers(updated);
      setCheckAllSuppliers(updated.length === suppiler.length);
    }
  };

  const handleSupplierCheckAll = () => {
    if (checkAllSuppliers) {
      setSelectedSuppliers([]);
      setCheckAllSuppliers(false);
    } else {
      const all = suppiler.map((s) => s.pearlcon_contact);
      setSelectedSuppliers(all);
      setCheckAllSuppliers(true);
    }
  };

  const [selectedPOs, setSelectedPOs] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // Handle select all checkbox
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedPOs([]);
    } else {
      setSelectedPOs(currentData.map((po) => po.id));
    }
    setSelectAll(!selectAll);
  };

  // Handle single checkbox
  const handleSelectPO = (id) => {
    setSelectedPOs((prev) =>
      prev.includes(id) ? prev.filter((poId) => poId !== id) : [...prev, id]
    );
  };

  // Delete selected POs
  const deleteSelectedPOs = async () => {
    if (selectedPOs.length === 0) {
      Swal.fire("Please select at least one PO to delete");
      return;
    }

    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to delete ${selectedPOs.length} PO(s).`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
    });

    if (!confirm.isConfirmed) return;

    try {
      await Promise.all(
        selectedPOs.map((id) => axios.delete(`${BASE_URL}/api/po/${id}`))
      );

      Swal.fire("Deleted!", "Selected POs have been deleted.", "success");
      setPoData((prev) => prev.filter((po) => !selectedPOs.includes(po.id)));
      setSelectedPOs([]);
      setSelectAll(false);
    } catch (error) {
      console.error(error);
      Swal.fire(
        error.response?.data?.message || "Failed to delete selected POs"
      );
    }
  };

  const DeletePO = async (poId) => {
    try {
      const res = await axios.delete(`${BASE_URL}/api/po/${poId}`);

      if (res.status === 200) {
        Swal.fire("po deleted successfully");

        // Optionally refresh your list
        setPoData((prev) => prev.filter((item) => item.id !== poId));
      }
    } catch (error) {
      console.error(error);
      Swal.fire(
        error.response?.data?.message || "Failed to delete RFQ. Try again."
      );
    }
  };
  const uniqueSuppliers = [...new Set(poData.map((s) => s.pearlcon_contact))];

  console.log("poLength", poLength);

  return (
    <div className="row">
      <div className="custom-2-5">
        <Sidebarpo />
      </div>
      <div className="custom-9-5 dashboardsclooer p-2">
        <h3>PO List</h3>

        <div className="row">
          <div className="col-lg-4">
            {/* <label> Search</label> */}
            <input
              className="form-control w-100"
              placeholder="Search by any field..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
            />
          </div>

          {/* Client Type Dropdown */}
          <div className="col-lg-3">
            <div className="dropdown">
              <button
                className="btn btn-outline-primary dropdown-toggle"
                type="button"
                id="clientDropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Filter by Client Type
              </button>
              <div
                className="dropdown-menu custom-dropdown"
                aria-labelledby="clientDropdown"
              >
                <label className="dropdown-item">
                  <input
                    type="checkbox"
                    checked={checkAllClients}
                    onChange={handleClientCheckAll}
                  />{" "}
                  <strong>All</strong>
                </label>
                <div className="dropdown-divider"></div>
                {clients.map((client, index) => (
                  <label key={index} className="dropdown-item">
                    <input
                      type="checkbox"
                      checked={selectedClients.includes(client.client_name)}
                      onChange={() =>
                        handleClientCheckboxChange(client.client_name)
                      }
                    />{" "}
                    {client.client_name}
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* Supplier Dropdown */}
          {/* Supplier Dropdown */}
          <div className="col-lg-3">
            <div className="dropdown">
              <button
                className="btn btn-outline-success dropdown-toggle"
                type="button"
                id="supplierDropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Filter by Pearlcon Contact
              </button>
              <div
                className="dropdown-menu custom-dropdown"
                aria-labelledby="supplierDropdown"
              >
                <label className="dropdown-item">
                  <input
                    type="checkbox"
                    checked={checkAllSuppliers}
                    onChange={handleSupplierCheckAll}
                  />{" "}
                  <strong>All</strong>
                </label>
                <div className="dropdown-divider"></div>
                {/* {uniqueSuppliers.map((supplier, index) => (
        <label key={index} className="dropdown-item">
          <input
            type="checkbox"
            checked={selectedSuppliers.includes(supplier.pearlcon_contact)}
            onChange={() => handleSupplierCheckboxChange(supplier.pearlcon_contact)}
          />{" "}
          {supplier.pearlcon_contact}
        </label>
      ))} */}

                {uniqueSuppliers.map((name, index) => (
                  <label key={index} className="dropdown-item">
                    <input
                      type="checkbox"
                      checked={selectedSuppliers.includes(name)}
                      onChange={() => handleSupplierCheckboxChange(name)}
                    />{" "}
                    {name}
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="row align-items-end mb-3 mt-3">
          {/* 🔹 Latest Update */}
          <div className="col-md-3">
            {/* <label className="form-label fw-semibold">Latest Update</label> */}
            <select
              // className="form-select"
              className="form-control"
              value={filterLatestUpdate}
              onChange={(e) => setFilterLatestUpdate(e.target.value)}
            >
              <option value="">All</option>
              {latestUpdateOptions.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>

          {/* 🔹 Date Type */}
          <div className="col-md-3">
            {/* <label className="form-label fw-semibold">Date Type</label> */}
            <select
              // className="form-select"
              className="form-control"
              value={dateType}
              onChange={(e) => setDateType(e.target.value)}
            >
              <option value="">Select Date Type</option>
              <option value="client_po_date">Client PO Date</option>
              <option value="client_delivery_date">Client Delivery Date</option>
              <option value="supplier_delivery_date">
                Supplier Delivery Date
              </option>
            </select>
          </div>

          {/* 🔹 From Date */}
          <div className="col-md-2">
            {/* <label className="form-label fw-semibold">From</label> */}
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          {/* 🔹 To Date */}
          <div className="col-md-2">
            {/* <label className="form-label fw-semibold">To</label> */}
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          {/* 🔹 Reset Button */}
          <div className="col-md-2 text-end">
            <button
              className="btn btn-secondary w-100"
              onClick={() => {
                setFilterLatestUpdate("");
                setDateType("");
                setStartDate("");
                setEndDate("");
              }}
            >
              Reset
            </button>
          </div>
        </div>

        <div className="mt-2">
          <div className="mb-1">
            {user.deletestatus === "1" && (
              <button
                className="btn btn-danger mb-1"
                onClick={deleteSelectedPOs}
              >
                Delete Selected
              </button>
            )}
          </div>
          <div
            className="table-responsive"
            style={{
              height: "calc(100vh - 225px",
              overflowY: "auto",
              overflowX: "auto",
              position: "relative",
            }}
          >
            <table
              className="table table-bordered custom-table"
              // style={{ width: "2000px" }}
            >
              <thead className="thead-sticky">
                <tr>
                  {user.deletestatus === "1" && (
                    <th className="sticky-col sticky-0 col-checkbox">
                      {" "}
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                  )}
                  <th className="sticky-col sticky-1 col-action">Action</th>
                  <th className="sticky-col sticky-2 col-rfq">Client Name</th>
                  <th className="sticky-col sticky-3 col-date">
                    Client PO Number
                  </th>
                  <th>Client PO Date</th>
                  <th> Current Status</th>
                  <th>Latest Update</th>
                  <th>Supplier Name</th>

                  <th>Item Description </th>
                  <th>Client PO Value</th>
                  <th>Currency</th>
                  <th>Client Delivery Date</th>
                  <th>Supplier PO Number</th>
                  <th>Supplier PO Value</th>
                  <th>Currency</th>
                  {/* <th>Fulfillment (Flow)</th> */}

                  <th>Pearlcon Contact</th>
                  <th>Supplier Payment</th>
                  <th>Supplier Delivery Date</th>
                  <th>Client Payment</th>
                  <th>RFQ Number</th>
                  <th>PO Attachment File</th>
                </tr>
              </thead>
              <tbody>
                {currentData.length > 0 ? (
                  currentData.map((po, index) => (
                    <tr key={index}>
                      {user.deletestatus === "1" && (
                        <td className="sticky-col sticky-0 col-checkbox">
                          <input
                            type="checkbox"
                            checked={selectedPOs.includes(po.id)}
                            onChange={() => handleSelectPO(po.id)}
                          />
                        </td>
                      )}
                      <td className="sticky-col sticky-1 col-action">
                        {/* {user.deletestatus === "1" && (
  <button
    className="btn btn-danger mx-2"
    onClick={() => DeletePO(po.id)}
  >
    D
  </button>
)} */}
                        <button
                          type="button"
                          className="btn btn-primary"
                          data-toggle="modal"
                          data-target="#statusModal"
                          onClick={() => openStatusModal(po)}
                        >
                          Edit
                        </button>
                        <Link
                          to={`/clonepo/${po.id}`}
                          className="btn btn-secondary mx-2"
                        >
                          Clone
                        </Link>
                      </td>
                      <td className="sticky-col sticky-2 col-rfq">
                        {limitWords(po.client_name)}
                      </td>
                      <td className="sticky-col sticky-3 col-date">
                        {limitWords(po.client_po_number)}
                      </td>
                      <td>{limitWords(po.client_po_date)}</td>
                      {/* <td>{limitWords(po.current_status)}</td> */}
                      <td>
                        <TruncatedText text={po.current_status} limit={50} />
                      </td>

                      <td>
                        <button
                          className="btn btn-sm"
                          style={{
                            backgroundColor: getBackgroundColor(
                              po.latest_update
                            ),
                          }}
                        >
                          {limitWordstwo(po.latest_update)}
                        </button>
                      </td>
                      <td>
                        <TruncatedTextSupplier
                          text={po.supplier_name}
                          limit={15}
                        />
                      </td>

                      <td>{limitWords(po.items_description)}</td>
                      <td>{limitWords(po.client_po_value)}</td>
                      <td>{limitWords(po.c_currency)}</td>
                      <td>{limitWords(po.client_delivery_date)}</td>
                      <td>{limitWords(po.supplier_po_number)}</td>
                      <td>{limitWords(po.supplier_po_value)}</td>
                      <td>{limitWords(po.currency)}</td>

                      <td>{limitWords(po.pearlcon_contact)}</td>

                      <td>
                        <button
                          className="btn btn-sm"
                          style={{
                            backgroundColor: getBackgroundColor(
                              po.supplier_payment
                            ),
                          }}
                        >
                          {limitWordstwo(po.supplier_payment)}
                        </button>
                      </td>
                      <td>{limitWords(po.supplier_delivery_date)}</td>
                      <td>
                        <button
                          className="btn btn-sm"
                          style={{
                            backgroundColor: getBackgroundColor(
                              po.client_payment
                            ),
                          }}
                        >
                          {limitWords(po.client_payment)}
                        </button>
                      </td>
                      <td>{limitWords(po.rfq_number)}</td>
                      <td>
                        <a
                          href={`${BASE_URL}/public/${po.po_attachment}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-outline-primary mt-2"
                        >
                          View Current File
                        </a>
                      </td>
                    </tr>
                  ))
                ) : (
                  /* ❌ NO DATA FOUND */
                  <tr>
                    <td
                      colSpan={user.deletestatus === "1" ? 22 : 21}
                      className=" text-muted py-4"
                      style={{ paddingLeft: "15px" }}
                    >
                      <strong>No data found</strong>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="mt-2 mb-0 d-flex justify-content-center">
              <nav>
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                    >
                      &laquo;
                    </button>
                  </li>

                  {getPaginationGroup().map((pageNumber) => (
                    <li
                      key={pageNumber}
                      className={`page-item ${
                        currentPage === pageNumber ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(pageNumber)}
                      >
                        {pageNumber}
                      </button>
                    </li>
                  ))}

                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                    >
                      &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>

        <div
          className="modal bd-example-modal-lg"
          id="statusModal"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Update PO</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div
                className="modal-body"
                style={{ height: "400px", overflow: "auto" }}
              >
                {selectedRFQ && (
                  <>
                    <form>
                      <div className="row">
                        <div className="form-group mb-3 col-lg-6">
                          <label>
                            <strong>PO Attachment</strong>
                          </label>
                          <br />
                          <input
                            type="file"
                            onChange={(e) => setFile1(e.target.files[0])}
                          />
                          {selectedRFQ?.po_attachment && (
                            <a
                              href={`${BASE_URL}/public/${selectedRFQ.po_attachment}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-primary mt-2"
                            >
                              View Current File
                            </a>
                          )}
                        </div>

                        <div className="form-group mb-3 col-lg-6">
                          <label>
                            <strong>
                              Client Name <span className="textred">*</span>
                            </strong>
                          </label>
                          <Select
                            name="client_name"
                            options={[
                              ...clients.map((c) => ({
                                label: c.client_name,
                                value: c.client_name,
                              })),
                              { label: "➕ Add New Client", value: "add_new" },
                            ]}
                            value={
                              selectedRFQ.client_name
                                ? {
                                    label: selectedRFQ.client_name,
                                    value: selectedRFQ.client_name,
                                  }
                                : null
                            }
                            onChange={(selectedOption) => {
                              if (!selectedOption) return;
                              const value = selectedOption.value;

                              if (value === "add_new") {
                                window.location.href = "/clientlist";
                                return;
                              }

                              handleInputChange({
                                target: { name: "client_name", value },
                              });
                            }}
                            placeholder="Select Client"
                            isSearchable
                            classNamePrefix="react-select"
                          />
                        </div>

                        {Object.entries({
                          supplier_name: "Supplier Name",
                          client_po_number: "Client PO Number",
                          supplier_po_number: "Supplier PO Number",
                          client_po_date: "Client PO Date",
                          supplier_po_value: "Supplier PO Value",
                          client_po_value: "Client PO Value",
                          supplier_delivery_date: "Supplier Delivery Date",
                          client_delivery_date: "Client Delivery Date",
                        }).map(([key, label]) => {
                          const inputType = key.toLowerCase().includes("date")
                            ? "date"
                            : "text";
                          const requiredFields = [
                            "client_po_number",
                            "client_po_date",
                            "client_delivery_date",
                            "supplier_delivery_date",
                          ];
                          const isRequired = requiredFields.includes(key);
                          const isReadOnly = key === "supplier_po_number";

                          return (
                            <div key={key} className="form-group mb-3 col-lg-6">
                              <label>
                                {label}{" "}
                                {isRequired && (
                                  <span className="textred">*</span>
                                )}
                              </label>
                              <input
                                type={inputType}
                                className="form-control"
                                name={key}
                                value={selectedRFQ[key] || ""}
                                onChange={handleInputChange}
                                readOnly={isReadOnly}
                              />
                            </div>
                          );
                        })}

                        <div className="form-group mb-3 col-lg-6">
                          <label>
                            <strong> Supplier Currency</strong>
                          </label>
                          <select
                            name="currency"
                            className="form-control"
                            value={selectedRFQ.currency}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            <option value="GBP">GBP</option>
                            <option value="USD">USD</option>
                            <option value="EURO">EURO</option>
                            <option value="SAR">SAR</option>
                            <option value="QD">QD</option>
                            <option value="AED">AED</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>

                        <div className="form-group mb-3 col-lg-6">
                          <label>
                            <strong>Client Currency</strong>
                          </label>
                          <select
                            name="c_currency"
                            className="form-control"
                            value={selectedRFQ.c_currency}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            <option value="GBP">GBP</option>
                            <option value="USD">USD</option>
                            <option value="EURO">EURO</option>
                            <option value="SAR">SAR</option>
                            <option value="QD">QD</option>
                            <option value="AED">AED</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>

                        {/* Supplier Payment Dropdown */}
                        <div className="form-group mb-3 col-lg-6">
                          <label>Supplier Payment</label>
                          <select
                            name="supplier_payment"
                            className="form-control"
                            value={selectedRFQ.supplier_payment || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            {supplierPaymentOptions.map((opt) => (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Client Payment Dropdown */}
                        <div className="form-group mb-3 col-lg-6">
                          <label>Client Payment</label>
                          <select
                            name="client_payment"
                            className="form-control"
                            value={selectedRFQ.client_payment || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            {clientPaymentOptions.map((opt) => (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            ))}
                          </select>
                        </div>

                        {Object.entries({
                          pearlcon_contact: "Pearlcon Contact",
                          rfq_number: "RFQ Number",
                          items_description: "Item Description",
                          current_status: "Current Status",
                        }).map(([key, label]) => {
                          const inputType = key.toLowerCase().includes("date")
                            ? "date"
                            : "text";
                          const requiredFields = [
                            "client_po_number",
                            "client_po_date",
                            "client_delivery_date",
                            "supplier_delivery_date",
                          ];
                          const isRequired = requiredFields.includes(key);

                          return (
                            <div key={key} className="form-group mb-3 col-lg-6">
                              <label>
                                {label}{" "}
                                {isRequired && (
                                  <span className="textred">*</span>
                                )}
                              </label>

                              {key === "current_status" ? (
                                <textarea
                                  className="form-control"
                                  name={key}
                                  rows={3}
                                  value={selectedRFQ[key] || ""}
                                  onChange={handleInputChange}
                                ></textarea>
                              ) : (
                                <input
                                  type={inputType}
                                  className="form-control"
                                  name={key}
                                  value={selectedRFQ[key] || ""}
                                  onChange={handleInputChange}
                                />
                              )}
                            </div>
                          );
                        })}

                        {/* Latest Update Dropdown */}
                        <div className="form-group mb-3 col-lg-6">
                          <label>Latest Update</label>
                          <select
                            name="latest_update"
                            className="form-control"
                            value={selectedRFQ.latest_update || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            {latestUpdateOptions.map((opt) => (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            ))}
                            <option value="Cancel">PO Cancel</option>

                          </select>
                        </div>
                      </div>
                    </form>
                  </>
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={submitStatusUpdate}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListPO;
